/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_0e7767e2"]'><div :class='["radio-group-column-num-demo"]'><div :class='["cube-radio-group-example"]'><cube-radio-group :options="(options)" :colNum="(3)" :value="checkedValue" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","checkedValue", "__mpx_event__", ["value"], undefined]])'></cube-radio-group></div><div :class='["view-desc"]'>selected value: {{ checkedValue }}</div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_0e7767e2"}'>
.radio-group-column-num-demo
  // TODO：CR 同理可抽到外层
  .cube-radio-group-example
    background-color #fff
    padding 5px 10px
  .desc
    margin-top 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_0e7767e2"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_0e7767e2"}
  /** script content **/
  require("./group-column-num.mpx.js?isComponent&outputPath=components%2Fgroup-column-num0e7767e2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./group-column-num.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fgroup-column-num0e7767e2%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_0e7767e2"],
    ctorType: "component",
    outputPath: "components/group-column-num0e7767e2/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-radio-group':getComponent(require("../../../packages/mpx-cube-ui/src/components/radio-group/index.mpx?isComponent&outputPath=components%2Findex467050cc%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>